module.exports = __webpack_public_path__ + "img/PropietarioDatos.59d04143.svg";